import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _trimInstanceProperty from "@babel/runtime-corejs3/core-js/instance/trim";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ResultsSection from "./results-section";
import { getSearchResults } from "../api/global-search-api";
import Popover from "@Shared/components/general/popover";
import Err from "../../../../routes/error";
import { debounce } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "GlobalSearchContainer",
  components: {
    Popover,
    ResultsSection
  },
  data() {
    return {
      loading: false,
      searchString: "",
      results: {},
      activeSearchRequest: null,
      debouncedSearch: null,
      searchRequestId: 0
    };
  },
  computed: {
    resultSections() {
      return _Object$keys(this.results);
    }
  },
  created() {
    this.debouncedSearch = debounce(this.performSearch, 300);
  },
  beforeDestroy() {
    this.invalidateCurrentSearch();
  },
  methods: {
    handleSearchInput() {
      var _context;
      const searchString = _trimInstanceProperty(_context = this.searchString).call(_context);
      const requestId = ++this.searchRequestId;
      this.cancelActiveSearch();
      this.debouncedSearch.cancel();
      this.results = {};
      this.closePopover(false);
      if (!searchString) {
        this.loading = false;
        return;
      }
      if (searchString.length < 3) {
        this.loading = false;
        return;
      }
      this.debouncedSearch(requestId, searchString);
    },
    async performSearch(requestId, searchString) {
      try {
        var _context2;
        this.loading = true;
        const {
          results
        } = await this.getResults(searchString, {
          beforeSend: request => {
            if (requestId !== this.searchRequestId) {
              request.abort();
              return;
            }
            this.activeSearchRequest = request;
          }
        });
        if (requestId !== this.searchRequestId || searchString !== _trimInstanceProperty(_context2 = this.searchString).call(_context2)) {
          return;
        }
        this.results = results;
        this.openPopover();
      } catch (e) {
        if ((e == null ? void 0 : e.statusText) !== "abort" && requestId === this.searchRequestId) {
          Err.handle(e);
        }
      } finally {
        if (requestId === this.searchRequestId) {
          this.activeSearchRequest = null;
          this.loading = false;
        }
      }
    },
    cancelActiveSearch() {
      if (this.activeSearchRequest) this.activeSearchRequest.abort();
      this.activeSearchRequest = null;
    },
    invalidateCurrentSearch() {
      var _this$debouncedSearch;
      this.searchRequestId += 1;
      (_this$debouncedSearch = this.debouncedSearch) == null ? void 0 : _this$debouncedSearch.cancel();
      this.cancelActiveSearch();
      this.loading = false;
    },
    openPopover() {
      this.$refs.popover.show();
    },
    closePopover(emitHidden = true) {
      if (emitHidden) this.$refs.popover.hide();else this.$refs.popover.hideSilently();
    },
    handlePopoverHidden() {
      this.invalidateCurrentSearch();
      this.searchString = "";
      this.results = {};
    },
    async getResults(searchString, ajaxOptions) {
      return getSearchResults(searchString, ajaxOptions);
    }
  }
});